export const API_URL = 'http://localhost:3001/api';